module.exports = __webpack_public_path__ + "img/indeximg2.678052e8.png";